import { ToggleButton, ToggleButtonGroup, clubbiStyled } from 'clubbi-ui'

export const StyledSelectionContainer = clubbiStyled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',
  gap: '8px',
  padding: '0 16px',
  paddingTop: '24px',
  position: 'relative',
}))

export const StyledTitle = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontWeight: 500,
  fontSize: '12px',
  justifyContent: 'space-between',
  width: '100% !important',
  [theme.breakpoints.up('md')]: {
    fontSize: theme.typography.fontSizeXXS,
  },
}))

export const StyledDeliveryDate = clubbiStyled('span')(({ theme }) => ({
  color: theme.palette.brandPurple.main,
  fontWeight: 700,
  fontSize: '12px',
}))

export const StyledTag = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontWeight: 400,
  lineHeight: '110%',
}))

export const StyledPriceContainer = clubbiStyled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'end',
  lineHeight: '110%',
}))

export const StyledToggleButtonGroup = clubbiStyled(ToggleButtonGroup)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  position: 'relative',
}))

export const StyledToggleButton = clubbiStyled(ToggleButton)(({ theme }) => ({
  textTransform: 'none',
  width: '100%',
  padding: '12px',
  fontSize: theme.typography.fontSize2XS,
  fontWeight: 400,
  borderRadius: '4px !important',
  display: 'flex',
  alignItems: 'start',
  justifyContent: 'space-between',
  border: `1px solid ${theme.palette.brandGrey[20]} !important`,
  marginLeft: '1px !important',
  color: theme.palette.brandGrey[100],
  backgroundColor: theme.palette.brandWhite.main,
  '.days-to-delivery': {
    paddingTop: '4px',
    flexDirection: 'column',
    color: theme.palette.brandGrey[60],
    fontWeight: 400,
  },
  '.free-shipping': {
    color: theme.palette.brandSuccess[70],
    fontWeight: 600,
  },

  '&.Mui-disabled': {
    border: `1px solid ${theme.palette.brandPurple[60]} !important`,
    backgroundColor: theme.palette.brandWhite.main,
    color: theme.palette.brandBlack.main,
    fontWeight: 600,
  },

  [theme.breakpoints.up('md')]: {
    fontSize: theme.typography.fontSizeXXS,
    '.days-to-delivery': {
      fontSize: theme.typography.fontSize2XS,
    },
  },
}))

export const StyledType = clubbiStyled('div')(() => ({
  textAlign: 'initial',
  flex: '1 !important',
}))

export const StyledDescriptions = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
}))

export const StyledParagraph = clubbiStyled('div')(({ theme }) => ({
  lineHeight: '110%',
}))

export const StyledAlert = clubbiStyled('div')(({ theme }) => ({
  color: theme.palette.brandAlert[50],
  lineHeight: '110%',
}))
